import React,{ FC } from "react";
import styles from "./index.module.less";
import "./index.less";
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";


const BillRelated: FC = () => {
  useDocumentTitle('开票规则')
  return <div className={styles.rule}>
    <div className={styles.paragraph}>
      <div className={styles.title}>一、充电开票规则</div>
      <div className={styles.content}>目前仅支持提供三个月内充电实付金额（不包含优惠券抵扣金额、折扣金额及各类电子券、积分抵扣等部分）的开票申请。</div>
    </div>
    <div className={styles.paragraph}>
      <div className={styles.content}>我们开具经主管税务机关批准的增值税电子普通发票。根据税务法律法规规定，如需要纸质发票的，您可以自行打印增值税电子普通发票的PDF版式文件。增值税电子普通发票打印后，其法律效力、基本用途、基本使用规定等与税务机关监制的增值税普通发票相同。</div>
    </div>
    <div className={styles.paragraph}>
      <div className={styles.title}>二、开票主体</div>
      <div className={styles.content}>提交开票申请的订单将按对应的实际发生业务公司名称（开票主体）进行开票，所开具的发票均为真实有效可正常报销使用。</div>
    </div>
    <div className={styles.paragraph}>
      <div className={styles.title}>三、发票获取</div>
      <div className={styles.content}>发票将发送至开票申请人填写的邮箱中，也可以在“开票历史”页面，选择“已开票”-“对应发票”-“下载PDF/图片”。</div>
    </div>
    <div className={styles.paragraph}>
      <div className={styles.title}>四、无法申请发票可能有以下原因：</div>
      <div className={styles.content}>1、未到开票时点∶当日的订单需支付成功24小时之后可申请开票；</div>
      <div className={styles.content}>2、储值卡消费/积分/折扣/优惠券抵扣部分不支持开票。</div>
    </div>
    <div className={styles.paragraph}>
      <div className={styles.title}>五、开票时间</div>
      <div className={styles.content}>发票申请提交后，将在15个工作日内开出发票。</div>
      <div className={styles.content}>温馨提示：已申请的发票不支持修改/重新开票。</div>
    </div>
    <div className={styles.paragraph}>
      <div className={styles.content}>如有疑问，可至绿喵-我的-联系客服咨询。</div>
    </div>
  </div>
}
export default BillRelated